var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',_vm._l((_vm.rows),function(th,index){return _c('row',{key:th.uuid,attrs:{"data":th,"index":index,"subtitle":_vm.subtitle,"infiniteScroll":_vm.infiniteScroll},on:{"onSortBy":_vm.onSortBy}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }